export default __webpack_public_path__ + "static/100--stacked-area-3a94a77852fd028709fb1031c5aa5b96.png";